import { callBackendApi } from "../../../components/service/axios";
import { ApplicationDownloadableFiles } from "./model/ApplicationDownloadableFiles";

export async function fetchAvailableDownloadsForApplication(appId: string): Promise<ApplicationDownloadableFiles> {
    return new ApplicationDownloadableFiles(
        await callBackendApi(
            "get", `/bff/review-management/applications/${appId}/available-downloads`
        )
    )
}

export async function fetchAvailableDownloadsForApplicationReview(appId: string, reviewId: string): Promise<ApplicationDownloadableFiles> {
    return new ApplicationDownloadableFiles(
        await callBackendApi(
            "get", `/bff/review-management/applications/${appId}/reviews/${reviewId}/available-downloads`
        )
    )
}